import { Button, Card } from "@procurement-agents/ui";
import type { HandoffChoicePayload, HandoffChoiceResume } from "@procurement-agents/scope-api";

/**
 * CHANGE_self_service: the requisition is written, and the person who asked for it decides who takes it from here.
 * Two equal options: procurement does the rest, as every request used to go, or they do it themselves as far as a
 * draft. Procurement reviews before anything is issued either way, so neither choice is the careful one.
 */
export function HandoffChoice({ payload, onSubmit, busy }: { payload: HandoffChoicePayload; onSubmit: (value: HandoffChoiceResume) => void; busy: boolean }) {
  return (
    <Card title="Your request is written. What next?">
      <p className="muted small">“{payload.requisition_title}”</p>
      <div className="handoff-options">
        <section className="handoff-option">
          <h3>Hand it to procurement</h3>
          <p>The procurement team takes it from here. You will be told when the scope of work is ready.</p>
          <Button variant="primary" onClick={() => onSubmit({ action: "hand_off" })} disabled={busy}>Hand to procurement</Button>
        </section>
        <section className="handoff-option">
          <h3>Continue myself</h3>
          <ol className="handoff-steps">{(payload.steps ?? []).map((s: string) => <li key={s}>{s}</li>)}</ol>
          <p className="muted small">About {payload.estimate_minutes} minutes. Procurement reviews it before anything is issued, and you can hand it over at any point.</p>
          <Button variant="primary" onClick={() => onSubmit({ action: "continue" })} disabled={busy}>Continue</Button>
        </section>
      </div>
    </Card>
  );
}
